function parseJson(value, fallback = {}) {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function getStorageValue(key) {
  const localValue = localStorage.getItem(key);
  if (localValue) return localValue;
  return sessionStorage.getItem(key) || '';
}

function getTokenFromPerson(person) {
  return (
    person?.token ||
    person?._auth?.token ||
    person?.body?.token ||
    person?.auth?.token ||
    ''
  );
}

function getServerIdFromPerson(person) {
  const serverId =
    person?.server?.id ||
    person?._auth?.server?.id ||
    person?.body?.server?.id ||
    person?.profile?.server_id ||
    person?.profile?._server?.id ||
    '';
  return serverId ? String(serverId) : '';
}

function getServerIdFromChild(child) {
  const serverId =
    child?.server_id ||
    child?._data?.server_id ||
    child?._server?.id ||
    child?.server?.id ||
    child?.profile?.server_id ||
    '';
  return serverId ? String(serverId) : '';
}

function getSelectedChildServerId() {
  const role = getStorageValue('currentRole') || 'parent';
  if (role !== 'parent') return '';

  const currentChildUin = String(getStorageValue('currentChildUin') || '').trim();
  if (!currentChildUin) return '';

  const children = parseJson(getStorageValue('childList') || '[]', []);
  if (!Array.isArray(children)) return '';

  const selectedChild = children.find((child) => String(child?.uin || '') === currentChildUin);
  return getServerIdFromChild(selectedChild);
}

export function getSessionToken() {
  const directToken =
    getStorageValue('token') ||
    getStorageValue('access_token') ||
    getStorageValue('auth_token');
  if (directToken) return directToken;

  const person = parseJson(getStorageValue('person') || '{}', {});
  const personToken = getTokenFromPerson(person);
  if (personToken) return personToken;

  const accounts = parseJson(getStorageValue('accounts') || '[]', []);
  if (Array.isArray(accounts)) {
    const accountToken = accounts
      .map((item) => getTokenFromPerson(item?.profile || {}))
      .find(Boolean);
    if (accountToken) return accountToken;
  }

  return '';
}

export function getSessionServerId() {
  const selectedChildServerId = getSelectedChildServerId();
  if (selectedChildServerId) return selectedChildServerId;

  const directServerId = getStorageValue('institution-id') || getStorageValue('server_id');
  if (directServerId) return directServerId;

  const person = parseJson(getStorageValue('person') || '{}', {});
  const personServerId = getServerIdFromPerson(person);
  if (personServerId) return personServerId;

  const accounts = parseJson(getStorageValue('accounts') || '[]', []);
  if (Array.isArray(accounts)) {
    const accountServerId = accounts
      .map((item) => getServerIdFromPerson(item?.profile || {}))
      .find(Boolean);
    if (accountServerId) return accountServerId;
  }

  return '';
}

export { getSelectedChildServerId };
